import { DB } from "@p0security/frontend-core/react";
import { installedItems } from "@p0security/shared/install/installed";
import type { ConfigOf } from "@p0security/shared/install/types";
import { doc, getDoc } from "firebase/firestore";
import { sortBy } from "lodash";

import type { FrontendInstallContext } from "./types";

/** An option provider that lists components from another installed integration.
 *
 * Makes a single read from Firestore when options are listed.
 */
export const otherInstalledIntegration =
  (args: { integration: string; component: string }) =>
  async ({ tenantId }: FrontendInstallContext<any>) => {
    const doc_ = await getDoc(
      doc(DB, `o/${tenantId}/integrations/${args.integration}`)
    );
    const data = doc_.data();
    if (!data) return [];
    return sortBy(
      Object.entries(
        installedItems(args.component, data as ConfigOf<Record<string, any>>)
      ).map(([id, item]) => ({
        id,
        label: item?.label ? `${item.label} (${id})` : id,
      })),
      "label"
    );
  };
